import React from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@mui/styles';
import { Button, FormControlLabel, Radio, RadioGroup } from '@mui/material';

import Macros from '../../common/Macros';
import ActionConfirmation from '../../common/ActionConfirmation';
import ComponentWrapper from '../../common/ComponentWrapper';

import CommonStyles from '../../common/CommonStyles';

const styles = {
  ...CommonStyles,
  innerContainer: {
    color: '#4E4C4C',
    padding: '10px',
    boxSizing: 'border-box',
  },
  frmControlLabel: {
    width: 'fit-content',
    marginLeft: '-10px',
    fontSize: 14,
  },
  radioItem: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  text: {
    color: '#4c4c4c',
    fontSize: '14px',
  },
};

class AppSettingsPage extends ComponentWrapper {
  state = {
    mode: 'private',
    macro: {},
    initialData: {
      mode: 'private',
      macro: {},
    },
    saveSettingsModal: {
      isOpened: false,
    },
  };

  componentDidMount() {
    document.title="App Settings | Milkyweb";

    const { setup } = this.props;

    let mode = setup.isPublic ? 'public' : 'private';
    const macro = setup.macro ? { ...setup.macro } : {};

    const initialData = {
      mode,
      macro: { ...macro },
    };

    this.setState({ initialData, macro, mode });
  };

  onSaveSettingsClick = () => {
    const { mode, macro } = this.state;

    let data = {
      isPublic: mode === 'public',
    };

    for (let property in macro) {
      if (!macro[property].length) delete macro[property];
    }
    if (Object.keys(macro).length !== 0) data.macro = macro;

    this.postWithData({
      url: '/rest/edit_app',
      data: data,
      cb: (data) => {
        if (data._status === 'error') {
          console.log(data);
        } else {
          this.toggleSaveModal(false);
          this.setState({
            macro: data.setup.macro || {},
            mode: data.setup.isPublic ? 'public' : 'private',
            initialData: {
              macro: data.setup.macro || {},
              mode: data.setup.isPublic ? 'public' : 'private',
            }
          });
        }
      }
    });
  };

  toggleSaveModal = (isOpened, title) => {
    const { saveSettingsModal } = this.state;

    saveSettingsModal.isOpened = isOpened;
    saveSettingsModal.title = title;

    this.setState({ saveSettingsModal });
  };

  setFunctionPerfValues = (type, value) => {
    const macro = { ...this.state.macro };

    macro[type] = value;

    this.setState({ macro });
  };

  render() {
    const { classes, setup } = this.props;
    const { mode, macro, initialData, saveSettingsModal } = this.state;

    let modificatorSaved = mode === initialData.mode;
    let scriptSaved = JSON.stringify(macro) === JSON.stringify(initialData.macro);

    return (
      <div className={`${classes.container}`}>
        <div style={{ margin: '10px 0 10px 40px', fontSize: 20, fontWeight: 600, color: '#4c4c4c' }}>
          App Settings
        </div>
      <div className={`${classes.m20} ${classes.p20}`} style={{ background: '#ffff', width: '50%' }}>

        <ActionConfirmation
          modalData={{
            warning: true,
            open: saveSettingsModal.isOpened,
            contentText: "Caution! Making changes to App Settings will affect related applications",
          }}
          acceptHandler={this.onSaveSettingsClick}
          onClose={() => this.toggleSaveModal(false)}
        />

        <div className={classes.innerContainer}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src="/images/app_integration_40px.svg" alt="app integration" className={classes.mr10} />
            <span style={{ fontSize: 20, color: '#4c4c4c', fontWeight: 550 }}>
              {setup.id} : {setup.title}
            </span>
          </div>
        </div>

        <div className={classes.innerContainer}>
          <RadioGroup
            value={mode}
          >
            <div className={classes.radioItem}>
              <FormControlLabel
                value="private"
                control={
                  <Radio
                    size='small'
                    color='default'
                    checked={mode === 'private'}
                    onChange={() => this.setState({ mode: 'private'})}
                  />
                }
              />
              <span className={classes.frmControlLabel}> Private </span>
              <div style={{ height: '20px', marginLeft: '5px', marginTop: '2px' }}>
                {mode === 'private' &&
                  <React.Fragment>
                    {!modificatorSaved ?
                      <span
                        style={{
                          color: '#347CFF',
                          fontWeight: 500,
                          height: '20px',
                          fontSize: 14,
                        }}
                      >
                        (not saved)
                      </span>
                    : null}
                  </React.Fragment>
                }
              </div>
            </div>

            <div className={classes.radioItem}>
              <FormControlLabel
                value="public"
                control={
                  <Radio
                    size='small'
                    color='default'
                    checked={mode === 'public'}
                    onChange={() => this.setState({ mode: 'public'})}
                  />
                }
              />
              <span className={classes.frmControlLabel}> Public </span>
              <div style={{ height: '20px', marginLeft: '5px', marginTop: '2px' }}>
                {mode === 'public' &&
                  <React.Fragment>
                    {!modificatorSaved ?
                      <span
                        style={{
                          color: '#347CFF',
                          fontWeight: 500,
                          height: '20px',
                          fontSize: 14
                        }}
                      >
                        (not saved)
                      </span>
                    : null}
                  </React.Fragment>
                }
              </div>
            </div>
          </RadioGroup>
        </div>

        <div className={classes.innerContainer}>
          <div
            className={`${classes.blockName}`}
            style={{ display: 'inline-flex', justifyContent: 'center' }}>
            <span
              style={{
                color: '#4c4c4c',
                fontWeight: 500,
                marginBottom: '7px',
                fontSize: 14
              }}>
              Import script
            </span>
            <div style={{ marginBottom: '7px', height: '20px', marginLeft: '5px' }}>
              {!scriptSaved ?
                <span
                  style={{
                    color: '#347CFF',
                    fontWeight: 500,
                    fontSize: 14
                  }}>
                  (not saved)
                </span>
              : null}
            </div>
          </div>
          <Macros
            editable={true}
            showCode={true}
            showScriptType={true}
            showReturnType={true}
            functionVal={(macro && macro.code) || ''}
            scriptType={(macro && macro.script_type) || ''}
            returnType={(macro && macro.return_type) || ''}
            setFunctionPerfValues={this.setFunctionPerfValues}
          />
          <div className={classes.mt20}>
            <Button
              size="small"
              onClick={() => this.toggleSaveModal(true)}
              className={`${classes.btnBig} ${classes.btnBigNormal}`}
            >
              Save
            </Button>
          </div>
        </div>
      </div>
      </div>
    )
  }
};

export default connect((state) => ({ setup: state.meta.setup }))(withStyles(styles)(AppSettingsPage));
